import { combineReducers } from "@reduxjs/toolkit";

import { answerReducer } from "@/features/answer";
import { assignmentReducer } from "@/features/assignment";
import { authorityReducer } from "@/features/authority";
import { sentimentCheckReducer } from "@/features/sentiment-check";
import { socraticReducer } from "@/features/socratic/socratic-slice/socratic-slice";
import { timelineReducer } from "@/features/timeline";
import { layoutReducer } from "@/stores/layout-slice";

// Create the root reducer independently to obtain the RootState type
export const rootReducer = combineReducers({
  assignment: assignmentReducer,
  timeline: timelineReducer,
  layout: layoutReducer,
  authority: authorityReducer,
  answer: answerReducer,
  sentimentCheck: sentimentCheckReducer,
  socratic: socraticReducer,
});
